'use client';
import React, { useState, useEffect } from 'react';
import { useProductDetails } from '../../context/ProductDetailsContext';

function ProductGallery() {
  const { product, loading } = useProductDetails();
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  useEffect(() => {
    setSelectedImageIndex(0);
  }, [product]);

  if (loading)
    return <p className="text-center py-10 text-gray-600">Loading product images...</p>;

  if (!product || !product.images?.length)
    return <p className="text-center py-10 text-gray-600">No images found for this product.</p>;

  const images = product.images;

  const handleThumbnailClick = (index) => setSelectedImageIndex(index);

  const handleKeyDown = (event, index) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleThumbnailClick(index);
    }
  };

  return (
    <div className="w-full max-w-[720px] min-w-60 max-md:max-w-full">
      <div className="w-full">
        {/* Mobile Layout */}
        <div className="flex flex-col md:hidden w-full">
          <div className="flex justify-center py-2.5 w-full overflow-x-auto">
            <div className="flex gap-2 px-4">
              {images.map((image, index) => (
                <button
                  key={index}
                  onClick={() => handleThumbnailClick(index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className={`flex-shrink-0 border-2 transition-all duration-200 hover:border-yellow-500 focus:border-yellow-500 focus:outline-none ${
                    selectedImageIndex === index ? 'border-yellow-500' : 'border-transparent'
                  }`}
                >
                  <img
                    src={image}
                    alt={`Product thumbnail ${index + 1}`}
                    className="object-contain w-[80px] h-[120px]"
                  />
                </button>
              ))}
            </div>
          </div>

          <div className="w-full text-center text-zinc-100">
            <div className="flex justify-center items-start w-full">
              <img
                src={images[selectedImageIndex]}
                alt="Main product image"
                className="object-contain w-full max-h-[600px]"
              />
            </div>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex gap-4 justify-center items-start w-full">
          <div className="flex flex-col py-2.5 w-20 max-h-[620px]">
            {images.map((image, index) => (
              <button
                key={index}
                onClick={() => handleThumbnailClick(index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className={`mb-2 border-2 transition-all duration-200 hover:border-yellow-500 focus:border-yellow-500 focus:outline-none ${
                  selectedImageIndex === index ? 'border-yellow-500' : 'border-transparent'
                }`}
              >
                <img
                  src={image}
                  alt={`Product thumbnail ${index + 1}`}
                  className="object-contain w-full max-h-[150px]"
                />
              </button>
            ))}
          </div>

          <div className="grow text-center max-w-[600px] min-h-[600px] text-zinc-100">
            <img
              src={images[selectedImageIndex]}
              alt="Main product image"
              className="object-contain w-full max-h-[700px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductGallery;
